function China({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_927)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
  <path d="M8.75625 9.73828L10.1375 13.9883H14.6062L10.9937 16.6195L12.375 20.8695L8.75625 18.2445L5.1375 20.8695L6.525 16.6195L2.90625 13.9883H7.375L8.75625 9.73828Z" fill="#FFDA44"/>
  <path d="M18.9687 24.7816L17.9125 23.4816L16.35 24.0879L17.2562 22.6816L16.2 21.3754L17.8187 21.8066L18.7312 20.4004L18.8187 22.0754L20.4437 22.5066L18.875 23.1066L18.9687 24.7816Z" fill="#FFDA44"/>
  <path d="M21.0687 20.9691L21.5687 19.3691L20.2 18.4004L21.875 18.3754L22.3687 16.7754L22.9125 18.3629L24.5875 18.3441L23.2437 19.3441L23.7812 20.9316L22.4125 19.9629L21.0687 20.9691Z" fill="#FFDA44"/>
  <path d="M23.9 11.7439L23.1625 13.2502L24.3625 14.4189L22.7063 14.1814L21.9688 15.6814L21.6813 14.0314L20.0188 13.7939L21.5063 13.0127L21.2188 11.3564L22.4188 12.5252L23.9 11.7439Z" fill="#FFDA44"/>
  <path d="M19.0125 7.18164L18.8875 8.85039L20.4438 9.48164L18.8125 9.88164L18.6938 11.5566L17.8125 10.1316L16.1813 10.5316L17.2625 9.25039L16.375 7.83164L17.9313 8.46289L19.0125 7.18164Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default China;
